export enum CountryEnum {
  RU = 'RU',
  BY = 'BY',
  KG = 'KG',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  AX = 'AX',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AI = 'AI',
  AO = 'AO',
  AD = 'AD',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AF = 'AF',
  BS = 'BS',
  BD = 'BD',
  BB = 'BB',
  BH = 'BH',
  BZ = 'BZ',
  BE = 'BE',
  BJ = 'BJ',
  BM = 'BM',
  BG = 'BG',
  BO = 'BO',
  BQ = 'BQ',
  BA = 'BA',
  BW = 'BW',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BF = 'BF',
  BI = 'BI',
  BT = 'BT',
  VU = 'VU',
  VA = 'VA',
  GB = 'GB',
  HU = 'HU',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  UM = 'UM',
  TL = 'TL',
  VN = 'VN',
  GA = 'GA',
  HT = 'HT',
  GY = 'GY',
  GM = 'GM',
  GH = 'GH',
  GP = 'GP',
  GT = 'GT',
  GF = 'GF',
  GN = 'GN',
  GW = 'GW',
  DE = 'DE',
  GG = 'GG',
  GI = 'GI',
  HN = 'HN',
  HK = 'HK',
  PS = 'PS',
  GD = 'GD',
  GL = 'GL',
  GR = 'GR',
  GE = 'GE',
  GU = 'GU',
  DK = 'DK',
  CD = 'CD',
  JE = 'JE',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EG = 'EG',
  ZM = 'ZM',
  ZW = 'ZW',
  IL = 'IL',
  IN = 'IN',
  ID = 'ID',
  JO = 'JO',
  IQ = 'IQ',
  IR = 'IR',
  IE = 'IE',
  IS = 'IS',
  ES = 'ES',
  IT = 'IT',
  YE = 'YE',
  KP = 'KP',
  CN = 'CN',
  CV = 'CV',
  KZ = 'KZ',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  QA = 'QA',
  KE = 'KE',
  CY = 'CY',
  KI = 'KI',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  XK = 'XK',
  CR = 'CR',
  CI = 'CI',
  CU = 'CU',
  KW = 'KW',
  CW = 'CW',
  LA = 'LA',
  LV = 'LV',
  LS = 'LS',
  LR = 'LR',
  LB = 'LB',
  LY = 'LY',
  LT = 'LT',
  LI = 'LI',
  LU = 'LU',
  MU = 'MU',
  MR = 'MR',
  MG = 'MG',
  YT = 'YT',
  MO = 'MO',
  MW = 'MW',
  MY = 'MY',
  ML = 'ML',
  MV = 'MV',
  MT = 'MT',
  MA = 'MA',
  MQ = 'MQ',
  MH = 'MH',
  MX = 'MX',
  FM = 'FM',
  MZ = 'MZ',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  MS = 'MS',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NE = 'NE',
  NG = 'NG',
  NL = 'NL',
  NI = 'NI',
  NU = 'NU',
  NZ = 'NZ',
  NC = 'NC',
  NO = 'NO',
  AE = 'AE',
  OM = 'OM',
  BV = 'BV',
  IM = 'IM',
  NF = 'NF',
  CX = 'CX',
  KY = 'KY',
  CK = 'CK',
  PN = 'PN',
  SH = 'SH',
  PK = 'PK',
  PW = 'PW',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  CG = 'CG',
  KR = 'KR',
  RE = 'RE',
  RW = 'RW',
  RO = 'RO',
  EH = 'EH',
  US = 'US',
  SV = 'SV',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SZ = 'SZ',
  MK = 'MK',
  MP = 'MP',
  SC = 'SC',
  BL = 'BL',
  MF = 'MF',
  PM = 'PM',
  SN = 'SN',
  VC = 'VC',
  KN = 'KN',
  LC = 'LC',
  RS = 'RS',
  SG = 'SG',
  SX = 'SX',
  SY = 'SY',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  SD = 'SD',
  SR = 'SR',
  SL = 'SL',
  TJ = 'TJ',
  TH = 'TH',
  TW = 'TW',
  TZ = 'TZ',
  TC = 'TC',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TV = 'TV',
  TN = 'TN',
  TM = 'TM',
  TR = 'TR',
  UG = 'UG',
  UZ = 'UZ',
  UA = 'UA',
  WF = 'WF',
  UY = 'UY',
  FO = 'FO',
  FJ = 'FJ',
  PH = 'PH',
  FI = 'FI',
  FK = 'FK',
  FR = 'FR',
  PF = 'PF',
  TF = 'TF',
  HM = 'HM',
  HR = 'HR',
  CF = 'CF',
  TD = 'TD',
  ME = 'ME',
  CZ = 'CZ',
  CL = 'CL',
  CH = 'CH',
  SE = 'SE',
  SJ = 'SJ',
  LK = 'LK',
  EC = 'EC',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  ET = 'ET',
  ZA = 'ZA',
  GS = 'GS',
  SS = 'SS',
  JM = 'JM',
  JP = 'JP',
  IMPORT_VID = 'IMPORT_VID',
  ABKH = 'ABKH',
}
